import { Component, OnInit } from '@angular/core';
import { AuthGoogleService } from '../service/auth-google.service';
import { ClientUser } from '../interface/user.interface';
import { AuthService } from '../service/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-process-data',
  templateUrl: './process-data.component.html',
  styleUrls: ['./process-data.component.scss'],
})
export class ProcessDataComponent implements OnInit {
  data: any;
  constructor(
    private authGoogle: AuthGoogleService,
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    setTimeout(() => {
      this.data = this.authGoogle.getProfile();
      this.showData();
    }, 6000);
  }

  ngOnInit(): void {
    this.showData();


  }

  showData() {
    const token = this.authGoogle.getToken();
    if(this.data.email === undefined)
      this.data.email = '';
    let request: ClientUser = {
      rut: '',
      password: '',
      passwordSii: '',
      oAuth2GoogleToken: token,
      email: this.data.email ?? ''
    };

    this.authService.login(request).subscribe({
      next: (data) => {
        this.authService.setToken(data.token);
        const redirect = localStorage.getItem('pathAnterior');
        if(redirect){
          localStorage.removeItem('pathAnterior');
          this.router.navigateByUrl(redirect);
        } else{
          this.router.navigateByUrl('/dashboards');
        }
      },
      error: (err) => {
        Swal.fire({
          title: 'Error',
          text: '¡Hubo Error, favor volver a ingresar',
          icon: 'error',
        });
        this.router.navigate(['/login']);
      },
    });
  }
}
